import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/Jobs.css";
import upload_icon from "../../../assets/svg/upload_icon.svg";
import excel_icon from "../../../assets/svg/excel_icon.svg";
import small_line from "../../../assets/svg/small_line.svg";
import delete_icon from "../../../assets/svg/delete_icon.svg";
import plus_icon from "../../../assets/svg/plus_icon.svg";
import plus_circle from "../../../assets/svg/plus-circle.svg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import download_arrow from "../../../assets/svg/download_arrow.svg";
import AsyncSelect from 'react-select/async';
import axiosInstance from "../../../axiosInstance";
import AdditionalPermissionWrapper from "../../../hooks/AdditionalPermissionWrapper";
import { usePermissions } from "../../../hooks/PermissionContext";
import DraggableDivider from "../DraggableDivider";
import split from "../../../assets/svg/split.svg";
import sales from "../../../assets/svg/sales.svg";
import cost from "../../../assets/svg/cost.svg";
import split_hover from "../../../assets/svg/split-b.svg";
import sales_hover from "../../../assets/svg/sales-b.svg";
import cost_hover from "../../../assets/svg/cost-b.svg";
import AddExistingNonPoJobModal from "./AddExistingNonPoJobModal";
import useAttachmentValidator from "../../AttachmentValidator/AttachmentValidator";

const AddExistingJob = ({
  isOpen,
  onClose,
  existingJobSelected,
  setExistingJobSelected,
}) => {
  let ModuleId = 23;
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);
  console.log("permission", permission);
  const { hasAdditionalPermission } = usePermissions();
  const [selectedproject, setselectedproject] = useState(0);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [showProjectSuggestions, setShowProjectSuggestions] = useState(false);
  const dropdownRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [jobOptions, setJobOptions] = useState([]);
  const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [inputValues, setInputValues] = useState({});
  const [projectId, setselectedprojectId] = useState(0);
  const [jobTypeId, setselectedjobTypeId] = useState(0);
  const [jobTypeName, setselectedjobTypeName] = useState("");
  const [selectedChargeIds, setSelectedChargeIds] = useState({});
  const [hasProjectChanged, setHasProjectChanged] = useState(false);
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  const [showVendorSuggestions, setShowVendorSuggestions] = useState({});
  const [vendorInputValues, setVendorInputValues] = useState({});
  const [selectedVendorIds, setSelectedVendorIds] = useState({});
  const [loadOptionsEnabled, setLoadOptionsEnabled] = useState(false);
  const navigate = useNavigate();
  const locationData = useLocation();
  const job_data = locationData.state?.job_data || {};
  const data = job_data?.data || {};
  const contract_id = data.contract_id;
  console.log("contract_id", contract_id);
  const salesRef = useRef(null);
  const costRef = useRef(null);
  const [viewModes, setViewModes] = useState({});
  const [salesInputValues, setSalesInputValues] = useState({});
  const [costInputValues, setCostInputValues] = useState({});
  const [selectedSalesChargeIds, setSelectedSalesChargeIds] = useState({});
  const [selectedCostChargeIds, setSelectedCostChargeIds] = useState({});
  const [salesSuggestionsMap, setSalesSuggestionsMap] = useState({});
  const [costSuggestionsMap, setCostSuggestionsMap] = useState({});
  const [showSalesSuggestionsMap, setShowSalesSuggestionsMap] = useState({});
  const [showCostSuggestionsMap, setShowCostSuggestionsMap] = useState({});
  const [costErrors, setCostErrors] = useState({});
  const [showPoPopup, setShowPoPopup] = useState(false);
  const [invoiceMode, setInvoiceMode] = useState("");
  const { validateAttachments } = useAttachmentValidator();
  const jobData = [
    {
      id: "83939930",
      name: "83939930",
      categories: [
        {
          id: 1,
          name: "Category 1",
          quantity: 340,
          rate: 45000,
          netValue: 67000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        },
      ]
    },
    {
      id: "53939930",
      name: "53939930",
      categories: [
        {
          id: 2,
          name: "Category 2",
          quantity: 210,
          rate: 32000,
          netValue: 67200,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "23939930",
      name: "23939930",
      categories: [
        {
          id: 3,
          name: "Category 3",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "743930290",
      name: "743930290",
      categories: [
        {
          id: 4,
          name: "Category 4",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "938493809",
      name: "938493809",
      categories: [
        {
          id: 5,
          name: "Category 5",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        },
      ]
    },
    {
      id: "793849380",
      name: "793849380",
      categories: [
        {
          id: 6,
          name: "Category 6",
          quantity: 340,
          rate: 45000,
          netValue: 67000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
  ];

  const [allCategories, setAllCategories] = useState([]);

  // When selected jobs change, update the categories
  useEffect(() => {
    const newCategories = [];
    selectedJobs.forEach(jobId => {
      const job = jobData.find(j => j.id === jobId);
      if (job) {
        newCategories.push(...job.categories);
      }
    });
    setAllCategories(newCategories);
  }, [selectedJobs]);

  const handleJobSelection = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
    setSelectedJobs(selectedOptions);
  };

  const handleRemoveJob = (jobIdToRemove) => {
    setSelectedJobs(prevSelectedJobs => {
      const jobIndexToRemove = prevSelectedJobs.findIndex(id => id === jobIdToRemove);

      // Remove categories
      setAllCategories(prev => {
        const jobToRemove = jobData.find(j => j.id === jobIdToRemove);
        if (!jobToRemove) return prev;

        const categoryIdsToRemove = jobToRemove.categories.map(c => c.id);
        return prev.filter(cat => !categoryIdsToRemove.includes(cat.id));
      });

      // Clear charge code input fields
      setInputValues(prev => {
        const newInputValues = { ...prev };
        delete newInputValues[jobIndexToRemove];
        return newInputValues;
      });

      // Clear selected charge IDs
      setSelectedChargeIds(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (key.startsWith(`${jobIndexToRemove}_`)) {
            delete updated[key];
          }
        });
        return updated;
      });

      // Clear suggestion visibility map
      setShowSuggestionsMap(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (key.startsWith(`${jobIndexToRemove}_`)) {
            delete updated[key];
          }
        });
        return updated;
      });

      // Return updated job selection
      return prevSelectedJobs.filter(id => id !== jobIdToRemove);
    });
  };


  // Function to add a Sales row
  const addSalesRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category, index) =>
        index === categoryId
          ? {
            ...category,
            salesRows: [
              ...category.salesRows,
              {
                chargecode: "",
                description: "",
                SalesunitQuantity: '',
                salesRemarks: '',
                salesRate: '',
                salesNetTotal: '0.00',
                salesUploadedFiles: [],
                salesContractValue: '0.00',
                costContractValue: '0.00',
                costUploadedFiles: [],
                profitAmount: '0.00',
                profitPercent: '0.00',
                po_wo_number: "",
                po_wo_date: "",
                uploadedFiles: [],
                isChecked: false
              },
            ],
          }
          : category
      )
    );
  };

  // Function to add a Cost row
  const addCostRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category, index) =>
        index === categoryId
          ? {
            ...category,
            costRows: [
              ...category.costRows,
              {
                chargecode: "",
                description: "",
                SalesunitQuantity: '',
                salesRemarks: '',
                salesRate: '',
                salesNetTotal: '0.00',
                salesUploadedFiles: [],
                costRemarks: '',
                CostunitQuantity: '',
                costRate: '',
                costNetTotal: '0.00',
                salesContractValue: '0.00',
                costContractValue: '0.00',
                costUploadedFiles: [],
                profitAmount: '0.00',
                profitPercent: '0.00',
                uploadedFiles: [],
                isChecked: false,
                po_wo_number: "",
                po_wo_date: "",
                vendor_invoice_number: "",
                vendor_invoice_date: ""
              },
            ],
          }
          : category
      )
    );
  };


  const handleSalesFileUpload = (e, categoryId, index, lineindex) => {
    const files = validateAttachments(e.target.files);
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: category.salesRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row, salesUploadedFiles: [...(row.salesUploadedFiles || []), ...files], salesAttachment: "", // clear existing
                  attachment_urls: {
                    ...row.attachment_urls,
                    sales: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleCostFileUpload = (e, categoryId, index, lineindex) => {
    const files = validateAttachments(e.target.files);
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            costRows: category.costRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row, costUploadedFiles: [...(row.costUploadedFiles || []), ...files], costAttachment: "", // clear existing
                  attachment_urls: {
                    ...row.attachment_urls,
                    cost: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveSalesFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: category.salesRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  salesUploadedFiles: row.salesUploadedFiles.filter((_, idx) => idx !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveCostFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            costRows: category.costRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  costUploadedFiles: row.costUploadedFiles.filter((_, idx) => idx !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveSalesAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: category.salesRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row, salesAttachment: "", attachment_urls: {
                    ...row.attachment_urls,
                    sales: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveCostAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            costRows: category.costRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row, costAttachment: "", attachment_urls: {
                    ...row.attachment_urls,
                    cost: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };


  const handleSalesInputChange = (e, index, rowIndex, field) => {
    const { value } = e.target;

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentIndex) => {
        if (currentIndex === index) {
          // Update the salesRows
          const updatedSalesRows = category.salesRows.map((row, i) =>
            i === rowIndex
              ? (() => {
                const updatedRow = { ...row, [field]: value };

                // Recalculate salesNetTotal when relevant fields change
                if (field === 'SalesunitQuantity' || field === 'salesRate') {
                  const salesQuantity = parseFloat(updatedRow.SalesunitQuantity) || 0;
                  const salesRate = parseFloat(updatedRow.salesRate) || 0;
                  updatedRow.salesNetTotal = (salesQuantity * salesRate).toFixed(2);
                }

                return updatedRow;
              })()
              : row
          );

          // After updating, recalculate totals including profit
          const salesNetTotal = updatedSalesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costNetTotal = category.costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...category,
            salesRows: updatedSalesRows,
            salesNetTotal: salesNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };

  const handleCostInputChange = (e, index, rowIndex, field) => {
    const { value } = e.target;

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentIndex) => {
        if (currentIndex === index) {
          // Update the costRows
          const updatedCostRows = category.costRows.map((row, i) =>
            i === rowIndex
              ? (() => {
                const updatedRow = { ...row, [field]: value };

                // Recalculate costNetTotal when relevant fields change
                if (field === 'CostunitQuantity' || field === 'costRate') {
                  const costQuantity = parseFloat(updatedRow.CostunitQuantity) || 0;
                  const costRate = parseFloat(updatedRow.costRate) || 0;
                  updatedRow.costNetTotal = (costQuantity * costRate).toFixed(2);
                }

                return updatedRow;
              })()
              : row
          );

          // After updating, recalculate totals including profit
          const costNetTotal = updatedCostRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const salesNetTotal = category.salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...category,
            costRows: updatedCostRows,
            costNetTotal: costNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };

  const deleteRow = (categoryId, rowIndex, rowType) => {
    const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

    if (categoryIndex === -1) {
      return;
    }

    const category = allCategories[categoryIndex];

    // Check if we're deleting from sales or cost rows
    const isSalesRow = rowType === 'sales';
    const targetRows = isSalesRow ? category.salesRows : category.costRows;

    if (targetRows.length <= 1) {
      toast.error("At least one row must remain, cannot delete.");
      return;
    }

    setAllCategories(prevCategories =>
      prevCategories.map(cat => {
        if (cat.id === categoryId) {
          // Create new arrays without the deleted row
          const newSalesRows = isSalesRow
            ? [...cat.salesRows].filter((_, i) => i !== rowIndex)
            : [...cat.salesRows];

          const newCostRows = !isSalesRow
            ? [...cat.costRows].filter((_, i) => i !== rowIndex)
            : [...cat.costRows];

          // Calculate new totals
          const salesNetTotal = newSalesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costNetTotal = newCostRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...cat,
            salesRows: newSalesRows,
            costRows: newCostRows,
            salesNetTotal: salesNetTotal.toFixed(2),
            costNetTotal: costNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return cat;
      })
    );

    // Update input values state
    if (isSalesRow) {
      setSalesInputValues(prevInputValues => {
        const newInputValues = { ...prevInputValues };
        if (newInputValues[categoryIndex]) {
          const rows = { ...newInputValues[categoryIndex] };
          delete rows[rowIndex];
          const shiftedRows = {};
          Object.keys(rows).forEach(key => {
            const keyNum = Number(key);
            shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
          });
          newInputValues[categoryIndex] = shiftedRows;
        }
        return newInputValues;
      });

      setSelectedSalesChargeIds(prevSelectedChargeIds => {
        const newSelectedChargeIds = {};
        Object.keys(prevSelectedChargeIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedChargeIds[key] = prevSelectedChargeIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
            }
          } else {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          }
        });
        return newSelectedChargeIds;
      });
    } else {
      setCostInputValues(prevInputValues => {
        const newInputValues = { ...prevInputValues };
        if (newInputValues[categoryIndex]) {
          const rows = { ...newInputValues[categoryIndex] };
          delete rows[rowIndex];
          const shiftedRows = {};
          Object.keys(rows).forEach(key => {
            const keyNum = Number(key);
            shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
          });
          newInputValues[categoryIndex] = shiftedRows;
        }
        return newInputValues;
      });

      setSelectedCostChargeIds(prevSelectedChargeIds => {
        const newSelectedChargeIds = {};
        Object.keys(prevSelectedChargeIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedChargeIds[key] = prevSelectedChargeIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
            }
          } else {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          }
        });
        return newSelectedChargeIds;
      });

      // Update vendor-related states for cost rows
      setVendorInputValues(prevVendorInputValues => {
        const newVendorInputValues = {};
        Object.keys(prevVendorInputValues).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newVendorInputValues[key] = prevVendorInputValues[key];
            } else if (rowIdx > rowIndex) {
              newVendorInputValues[`${catIndex}_${rowIdx - 1}`] = prevVendorInputValues[key];
            }
          } else {
            newVendorInputValues[key] = prevVendorInputValues[key];
          }
        });
        return newVendorInputValues;
      });

      setSelectedVendorIds(prevSelectedVendorIds => {
        const newSelectedVendorIds = {};
        Object.keys(prevSelectedVendorIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedVendorIds[key] = prevSelectedVendorIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedVendorIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedVendorIds[key];
            }
          } else {
            newSelectedVendorIds[key] = prevSelectedVendorIds[key];
          }
        });
        return newSelectedVendorIds;
      });
    }

    // Update suggestions map
    setSuggestionsMap(prev => {
      const newMap = { ...prev };
      if (newMap[categoryIndex]) {
        const rows = { ...newMap[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newMap[categoryIndex] = shiftedRows;
      }
      return newMap;
    });
  };

  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };



  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axiosInstance.get("/costsolution/projects/autosuggestion");
        if (response.data) {
          setProjectOptions(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      }
    };

    fetchProjects();
  }, []);

  // useEffect(() => {
  //   setAllCategories(prevCategories => {
  //     const updatedCategories = [...prevCategories];

  //     selectedJobs.forEach((jobValue) => {
  //       const alreadyExists = updatedCategories.some(cat => cat.id === jobValue);
  //       if (!alreadyExists) {
  //         let jobObject = {};
  //         if (!jobObject.id) {
  //           // Fallback if no lines found or create mode
  //           jobObject = {
  //             id: jobValue,
  //             name: `Category ${jobValue}`,
  //             rows: [{
  //               billingtype: "",
  //               elements: "",
  //               remarks: "",
  //               charge_id: 0,
  //               contract_charge_line_table_id: null,
  //               description: '',
  //               unitQuantity: '',
  //               salesRemarks: '',
  //               salesRate: '',
  //               salesNetTotal: '0.00',
  //               costRemarks: '',
  //               costRate: '',
  //               costNetTotal: '0.00',
  //               salesContractValue: '0.00',
  //               costContractValue: '0.00',
  //               profitAmount: '0.00',
  //               profitPercent: '0.00',
  //               chargecode: '',
  //               uploadedFiles: [],
  //               isChecked: false,
  //               attachment_urls: { sales: null, cost: null },
  //               salesAttachment: "",
  //               costAttachment: ""
  //             }],
  //             salesNetTotal: '0.00',
  //             costNetTotal: '0.00',
  //             profitAmount: '0.00',
  //             profitPercent: '0.00'
  //           };
  //         }

  //         updatedCategories.push(jobObject);
  //       }
  //     });

  //     // Filter out removed jobs if selectedJobs has changed
  //     return updatedCategories.filter(cat => selectedJobs.includes(cat.id));
  //   });
  // }, [selectedJobs, data?.job_id]);

  useEffect(() => {
    setAllCategories(prevCategories => {
      const updatedCategories = [...prevCategories];

      selectedJobs.forEach((jobValue) => {
        const alreadyExists = updatedCategories.some(cat => cat.id === jobValue);
        if (!alreadyExists) {
          let jobObject = {};

          if (!jobObject.id) {
            // Fallback if no lines found or create mode
            jobObject = {
              id: jobValue,
              name: `Category ${jobValue}`,
              salesRows: [{
                billingtype: "",
                elements: "",
                remarks: "",
                charge_id: 0,
                contract_charge_line_table_id: null,
                description: '',
                SalesunitQuantity: '',
                salesRemarks: '',
                salesRate: '',
                salesNetTotal: '0.00',
                salesContractValue: '0.00',
                chargecode: '',
                uploadedFiles: [],
                isChecked: false,
                attachment_urls: { sales: null, cost: null },
                salesAttachment: "",
                po_wo_number: null,
                po_wo_date: null
              }],
              costRows: [{
                billingtype: "",
                elements: "",
                remarks: "",
                charge_id: 0,
                contract_charge_line_table_id: null,
                description: '',
                CostunitQuantity: '',
                costRemarks: '',
                costRate: '',
                costNetTotal: '0.00',
                costContractValue: '0.00',
                chargecode: '',
                uploadedFiles: [],
                isChecked: false,
                attachment_urls: { sales: null, cost: null },
                costAttachment: "",
                vendor_name: "",
                vendor_id: 0,
                po_wo_number: null,
                po_wo_date: null
              }],
              salesNetTotal: '0.00',
              costNetTotal: '0.00',
              profitAmount: '0.00',
              profitPercent: '0.00'
            };
          }

          updatedCategories.push(jobObject);
        }
      });

      // Filter out removed jobs if selectedJobs has changed
      return updatedCategories.filter(cat => selectedJobs.includes(cat.id));
    });
  }, [selectedJobs, data?.job_id]);

  const fetchSalesSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      const response = await axiosInstance.get(
        `/getnonprojectsaleschargecodes`,
        { params: { term: searchTerm } }
      );

      if (response.data?.chargecodes) {
        setSalesSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {};
          updated[index][rowIndex] = response.data.chargecodes;
          return updated;
        });

        setShowSalesSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch sales suggestions", err);
      setSalesSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = [];
        return updated;
      });
    }
  };

  const fetchCostSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      const response = await axiosInstance.get(
         `/getnonprojectcostchargecodes`,
        { params: { term: searchTerm } }
      );

      if (response.data?.chargecodes) {
        setCostSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {};
          updated[index][rowIndex] = response.data.chargecodes;
          return updated;
        });

        setShowCostSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch cost suggestions", err);
      setCostSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = [];
        return updated;
      });
    }
  };

  const calculateCategoryTotals = (category) => {
    const salesTotals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    const costTotals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    // Calculate sales totals
    category.salesRows.forEach(row => {
      salesTotals.quantity += parseFloat(row.SalesunitQuantity) || 0;
      salesTotals.rate += parseFloat(row.salesRate) || 0;
      salesTotals.netValue += parseFloat(row.salesNetTotal) || 0;
    });

    // Calculate cost totals
    category.costRows.forEach(row => {
      costTotals.quantity += parseFloat(row.CostunitQuantity) || 0;
      costTotals.rate += parseFloat(row.costRate) || 0;
      costTotals.netValue += parseFloat(row.costNetTotal) || 0;
    });

    return {
      salesTotals,
      costTotals
    };
  };

  const fetchVendorSuggestions = async (searchTerm = "") => {
    try {
      const response = await axiosInstance.get(
        "/vendor/autosuggestion",
        { params: { term: searchTerm } }
      );
      return response.data?.autosuggestion || [];
    } catch (error) {
      console.error("Failed to fetch vendor suggestions:", error);
      return [];
    }
  };

  const loadExistingJobOptions = async (inputValue) => {
    if (!loadOptionsEnabled) return [];
    try {
      const response = await axiosInstance.get(
        `/job/additional_charges_existing_job_autosuggestion?term=${inputValue}`
      );
      return response.data?.autosuggestion?.map(item => ({
        ...item,
        projectId: item.project_id,
        jobTypeId: item.job_type_id,
        jobTypeName: item.job_type_name,
      })) || [];
    } catch (error) {
      console.error("Error fetching job suggestions:", error);
      return [];
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setAllCategories([]);
      setSelectedJobs([]);
      setExistingJobSelected(null);
      setInputValues({});
      setSelectedChargeIds({});
      setVendorInputValues({});
      setSelectedVendorIds({});
    }
  }, [isOpen]);

  const validateChargeCodes = (invoiceType) => {
    let isValid = true;

    allCategories.forEach((category, categoryIndex) => {

      if (invoiceType === "sales") {
        category.salesRows.forEach((row, rowIndex) => {
          const chargeId = selectedSalesChargeIds[`${categoryIndex}_${rowIndex}`];

          if (!chargeId) {
            toast.error("At least one Sales row is required to generate a Sales invoice.");
            isValid = false;
          }
        });
      }

      if (invoiceType === "cost") {
        category.costRows.forEach((row, rowIndex) => {
          const chargeId = selectedCostChargeIds[`${categoryIndex}_${rowIndex}`];

          if (!chargeId) {
            toast.error("At least one Cost row is required to generate a Cost invoice.");
            isValid = false;
          }
        });
      }

    });

    return isValid;
  };

  const handleCostInvoiceClick = () => {
    const isValid = validateChargeCodes("cost");

    if (!isValid) {
      return;
    }

    setShowPoPopup(true);
  };


  const handleGenerateInvoice = async (invoiceType) => {
    try {
      if (!validateChargeCodes(invoiceType)) {
        return;
      }

      const jobId = existingJobSelected?.value || 0;

      if (!jobId) {
        toast.error("Missing Job ID or Job Lines. Please fill all required fields.");
        return;
      }

      const jobLines = [];

      allCategories.forEach((category, categoryIndex) => {

        category.salesRows.forEach((row, rowIndex) => {
          const salesKey = row.salesUploadedFiles?.length
            ? `sales_${categoryIndex}_${rowIndex}`
            : null;

          jobLines.push({
            charge_id: selectedSalesChargeIds[`${categoryIndex}_${rowIndex}`] || 0,
            job_line: {
              sales: [{
                job_type_id: jobTypeId,
                project_id: projectId,
                charge_id: selectedSalesChargeIds[`${categoryIndex}_${rowIndex}`] || 0,
                description_of_charges: row.description || "",
                unit_of_quantity: parseFloat(row.SalesunitQuantity) || 0,
                unit_of_rate: parseFloat(row.salesRate) || 0,
                net_total: parseFloat(row.salesNetTotal) || 0,
                accrual: row.salesNetTotal || "0",
                remarks: row.salesRemarks || "",
                po_wo_number: row.po_wo_number || null,
                po_wo_date: row.po_wo_date || null,
                attachment_key: salesKey
              }]
            }
          });
        });

        category.costRows.forEach((row, rowIndex) => {
          const costKey = row.costUploadedFiles?.length ? `cost_${categoryIndex}_${rowIndex}` : null;

          jobLines.push({
            charge_id: selectedCostChargeIds[`${categoryIndex}_${rowIndex}`] || 0,
            job_line: {
              cost: [{
                job_type_id: jobTypeId,
                project_id: projectId,
                charge_id: selectedCostChargeIds[`${categoryIndex}_${rowIndex}`] || 0,
                vendor_id: selectedVendorIds[`${categoryIndex}_${rowIndex}`] || 0,
                description_of_charges: row.description || "",
                unit_of_quantity: parseFloat(row.CostunitQuantity) || 0,
                unit_of_rate: parseFloat(row.costRate) || 0,
                net_total: parseFloat(row.costNetTotal) || 0,
                accrual: row.costNetTotal || "0",
                remarks: row.costRemarks || "",
                po_wo_number: row.po_wo_number || null,
                po_wo_date: row.po_wo_date || null,
                attachment_key: costKey,
                vendor_inv_number: row.vendor_invoice_number || null,
                vendor_inv_date: row.vendor_invoice_date || null,
              }]
            }
          });
        });

      });

      if (jobLines.length === 0) {
        toast.error("Missing Job ID or Job Lines.");
        return;
      }

      const data = {
        job_id: jobId,
        invoice_type: invoiceType,
        ...(invoiceType === "cost" && {
          cost_invoice_type: invoiceMode?.toUpperCase()
        }),
        job_lines: jobLines
      };

      if (invoiceType === "cost") {

        if (!invoiceMode) {
          toast.error("Please select PO or Non-PO to generate the Cost invoice.");
          return;
        }

        try {
          const validateResponse = await axiosInstance.post(
            "/job/validate_additional_cost_charges",
            { data: JSON.stringify(data) }   
          );

          if (!validateResponse.data?.success) {
            toast.error(validateResponse.data?.message || "Cost validation failed.");
            return; 
          }
        } catch (error) {
          toast.error(
            error.response?.data?.message ||
            "Cost validation failed."
          );
          return; 
        }
      }

      const formDataPayload = new FormData();
      formDataPayload.append("data", JSON.stringify(data));

      allCategories.forEach((category, categoryIndex) => {

        category.salesRows.forEach((row, rowIndex) => {
          const salesKey = `sales_${categoryIndex}_${rowIndex}`;
          if (row.salesUploadedFiles?.length) {
            row.salesUploadedFiles.forEach((file) => {
              formDataPayload.append(`attachments[${salesKey}][]`, file);
            });
          }
        });

        category.costRows.forEach((row, rowIndex) => {
          const costKey = `cost_${categoryIndex}_${rowIndex}`;
          if (row.costUploadedFiles?.length) {
            row.costUploadedFiles.forEach((file) => {
              formDataPayload.append(`attachments[${costKey}][]`, file);
            });
          }
        });
      });

      console.log("Submitting Invoice FormData:", data);

      const response = await axiosInstance.post(
        "/job/additional_charges_existing_job",
        formDataPayload,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );

      if (!response.data || response.data.success === false) {
        toast.error(
          response.data?.message ||
          `Failed to generate ${invoiceType} invoice`
        );
        return;
      }

      toast.success(
        `${invoiceType === "sales" ? "Sales" : "Cost"} invoice generated successfully!`
      );

      const route =
        invoiceType === "sales"
          ? "/salesBillPage"
          : "/costBillPage";

      navigate(route, {
        state: {
          billData: response.data,
          selectedBills: jobId,
          billType: invoiceType
        }
      });

      onClose();

    } catch (error) {
      toast.error(
        error.response?.data?.message ||
        `Failed to generate ${invoiceType} invoice`
      );
    }
  };

  if (!isOpen) return null;

  const handleViewModeChange = (categoryId, mode) => {
    setViewModes(prev => ({
      ...prev,
      [categoryId]: mode
    }));
  };

  const getViewModeForCategory = (categoryId) => {
    return viewModes[categoryId] || "split";
  };



  return (
    <>
      <div className="existing-job-popup-overlay">
        <div className="existing-job-popup" style={{
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <div className="existing-job-popup-header">
            <h3>Add Existing Job</h3>
            <button className="existing-job-close-btn" onClick={onClose}>
              &times;
            </button>
          </div>

          <div className="existing-job-popup-content" style={{
            flex: 1,
            overflowY: 'auto',
          }}>
            <div className="existing-job-input-field" style={{ position: 'relative', zIndex: 1000 }}>
              <label className="existing-job-label">Job Number</label>
              <AsyncSelect
                className="existing-job-autosuggest"
                cacheOptions
                defaultOptions
                loadOptions={loadExistingJobOptions}
                onFocus={() => setLoadOptionsEnabled(true)}
                onChange={(selectedOption) => {
                  setExistingJobSelected(selectedOption);

                  setselectedprojectId(selectedOption?.projectId || 0);
                  setselectedjobTypeId(selectedOption?.jobTypeId || 0);
                  setselectedjobTypeName(selectedOption?.jobTypeName || "");

                  if (selectedOption?.value) {
                    setSelectedJobs([selectedOption.value]);
                  } else {
                    setSelectedJobs([]);
                  }
                }}
                value={existingJobSelected}
                placeholder="Search job number..."
                isClearable
                menuPortalTarget={document.body}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "40px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    borderColor: "#D0D6DF",
                    "&:hover": { borderColor: "#454CF2" },
                  }),
                  menu: (base) => ({
                    ...base,
                    fontSize: "14px",
                    zIndex: 9999,
                  }),
                  menuList: (base) => ({
                    ...base,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            </div>


            {existingJobSelected && (
              <div className="invoice_popup_categories" style={{ padding: '0px' }}>
                {allCategories.map((category, index) => {
                  const totals = calculateCategoryTotals(category);
                  const jobType = jobOptions.find(job => job.value === category.id);
                  console.log("category salesNetTotal.....", category);
                  console.log("category rowsssssss.....", category.rows);
                  console.log("category row.....", category.row);
                  console.log("category salesNetTotal.....", category.salesNetTotal);
                  return (
                    <div key={category.id} className="invoice_popup_outercategory">
                      <div className="invoice_popup_category_header">
                        <div className="category_name_left">
                          <span className="category_name">
                            Job Type -  {jobTypeName}
                          </span>
                        </div>
                        <div style={{
                          display: "flex",
                          gap: "12px",
                          fontSize: '12px',
                          flexWrap: "wrap"
                        }}>
                          {/* SALES BOX */}
                          <div style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            padding: "12px 16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            width: 'auto',
                            height: '30px',
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                          }}>
                            <span style={{ color: "green", fontWeight: "600" }}>SALES :</span>
                            <span style={{ color: "#000" }}>Net total : ₹ {category.salesNetTotal?.toLocaleString()}</span>
                          </div>

                        <div style={{
                          width: "1px",
                          backgroundColor: "#ccc",
                          alignSelf: "stretch"
                        }} />

                          {/* COST BOX */}
                          <div style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            padding: "12px 16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            width: 'auto',
                            height: '30px',
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                          }}>
                            <span style={{ color: "#007bff", fontWeight: "600" }}>COST :</span>
                            <span style={{ color: "#000" }}>Net total : ₹ {category.costNetTotal?.toLocaleString()}</span>
                          </div>

                      </div>
                    </div>

                    <div className="invoice_popup_category_subheader">
                      <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                        <div style={{
                          display: "flex",
                          gap: "12px",
                          fontSize: '12px',
                          flexWrap: "wrap",
                          flexGrow: 1,
                          justifyContent: "flex-start",
                          minWidth: "min-content",
                          padding: '10px',
                          cursor: 'pointer',
                          fontWeight: '600'
                        }}>
                          <div onClick={() => handleViewModeChange(category.id, "split")} style={{
                            backgroundColor: getViewModeForCategory(category.id) === "split" ? "#D0E6FF" : "#EDF3F9",
                            borderRadius: "10px",
                            padding: "12px 16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            height: '30px',
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            flexShrink: 0,
                            color: getViewModeForCategory(category.id) === "split" ? "#007bff" : "",
                            transition: "all 0.3s ease",
                          }}>
                            <img src={getViewModeForCategory(category.id) === "split" ? split_hover : split} alt="Split View" />
                            <span style={{ transition: "color 0.3s ease" }}>Split View</span>
                          </div>
                          <div style={{
                            width: "1px",
                            backgroundColor: "#ccc",
                            alignSelf: "stretch",
                            flexShrink: 0
                          }} />
                          <div onClick={() => handleViewModeChange(category.id, "sales")} style={{
                            backgroundColor: getViewModeForCategory(category.id) === "sales" ? "#D0E6FF" : "#EDF3F9",
                            borderRadius: "10px",
                            padding: "12px 16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            height: '30px',
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            flexShrink: 0,
                            color: getViewModeForCategory(category.id) === "sales" ? "#007bff" : "",
                            transition: "all 0.3s ease",
                          }}>
                            <img src={getViewModeForCategory(category.id) === "sales" ? cost_hover : cost} alt="Sales View" />
                            <span style={{ transition: "color 0.3s ease" }}>Sales View</span>
                          </div>
                          <div style={{
                            width: "1px",
                            backgroundColor: "#ccc",
                            alignSelf: "stretch",
                            flexShrink: 0
                          }} />
                          <div onClick={() => handleViewModeChange(category.id, "cost")} style={{
                            backgroundColor: getViewModeForCategory(category.id) === "cost" ? "#D0E6FF" : "#EDF3F9",
                            borderRadius: "10px",
                            padding: "12px 16px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            height: '30px',
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            flexShrink: 0,
                            color: getViewModeForCategory(category.id) === "cost" ? "#007bff" : "",
                            transition: "all 0.3s ease",
                          }}>
                            <img src={getViewModeForCategory(category.id) === "cost" ? sales_hover : sales} alt="Sales View" />
                            <span style={{ transition: "color 0.3s ease" }}>Cost View</span>
                          </div>
                        </div>
                        <div className="tables-wrapper">
                          {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "sales") && (
                            <div className="table-container sales-table" ref={salesRef} style={{
                              position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "0 0 50%" : "1 1 100%",
                              width: getViewModeForCategory(category.id) === "split" ? "50%" : "100%", transition: 'flex 0.2s ease',
                              display: getViewModeForCategory(category.id) === "split" ? "block" :
                                (getViewModeForCategory(category.id) === "sales" ? "block" : "none")
                            }}>
                              <table className="invoice_table">
                                <thead>
                                  <tr>
                                    <th colSpan="9" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
                                  </tr>
                                  <tr>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>CHARGE CODE</th>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>DESCRIPTION</th>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO NO</th>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO DATE</th>
                                    <th style={{ backgroundColor: '#D9FFE2', padding: '10px' }}>REMARKS</th>
                                    {/* <th style={{ backgroundColor: '#D9FFE2' }}>CONTRACT VALUE</th> */}
                                    <th style={{ backgroundColor: '#D9FFE2' }}>QUANTITY</th>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>RATE</th>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>NET TOTAL</th>
                                    <th style={{ backgroundColor: '#D9FFE2' }}>ATTACHMENT</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {category.salesRows.map((row, lineindex) => (
                                    <tr key={lineindex}>
                                      <td style={{ position: "relative" }}>
                                        <input
                                          type="text"
                                          style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                          value={salesInputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                          onChange={(e) => {
                                            const val = e.target.value;
                                            handleSalesInputChange(e, index, lineindex, "chargecode");
                                            setSalesInputValues((prev) => ({
                                              ...prev,
                                              [index]: {
                                                ...prev[index],
                                                [lineindex]: val,
                                              },
                                            }));
                                            fetchSalesSuggestions(val, lineindex, index);
                                          }}
                                          onFocus={() => {
                                            const list = suggestionsMap[index]?.[lineindex] || [];
                                            if (list.length > 0) {
                                              setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                            }
                                          }}
                                          onBlur={() => {
                                            setTimeout(() => {
                                              setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                            }, 200);
                                          }}
                                          className="invoice_narrow_input_chargecode"
                                          placeholder="Search"
                                        />

                                        {showSalesSuggestionsMap[`${index}_${lineindex}`] && salesSuggestionsMap[index]?.[lineindex]?.length > 0 && (
                                          <ul
                                            style={{
                                              position: "absolute",
                                              top: "100%",
                                              left: 0,
                                              right: 0,
                                              backgroundColor: "white",
                                              border: "1px solid #ccc",
                                              zIndex: 999,
                                              maxHeight: "150px",
                                              overflowY: "auto",
                                              margin: 0,
                                              padding: 0,
                                              listStyle: "none",
                                              fontFamily: 'Work Sans'
                                            }}
                                          >
                                            {salesSuggestionsMap[index]?.[lineindex].map((item) => (
                                              <li
                                                key={item.value}
                                                onMouseDown={() => {
                                                  const selected = item.label;
                                                  const chargeId = item.value;

                                                  setSalesInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: selected,
                                                    },
                                                  }));

                                                  setSelectedSalesChargeIds((prev) => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: chargeId
                                                  }));

                                                  handleSalesInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                  setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));

                                                  const splitParts = selected.split("-");
                                                  const chargeCodeOnly = splitParts[0] || "";
                                                  const descriptionOnly = splitParts.slice(1).join("-") || "";

                                                  setSalesInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: chargeCodeOnly,
                                                    },
                                                  }));

                                                  handleSalesInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");
                                                  handleSalesInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                                }}
                                                style={{
                                                  padding: "8px",
                                                  cursor: "pointer",
                                                  borderBottom: "1px solid #eee",
                                                }}
                                              >
                                                {item.label}
                                              </li>
                                            ))}
                                          </ul>
                                        )}
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          value={row.description}
                                          onChange={(e) => {
                                            handleSalesInputChange(e, index, lineindex, "description");
                                          }}
                                          style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                          className="invoice_narrow_input_description"
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="text"
                                          value={row.po_wo_number}
                                          onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                              handleSalesInputChange(e, index, lineindex, "po_wo_number");
                                            }
                                          }}
                                          className="invoice_narrow_input_quantity"
                                          style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="date"
                                          value={row.po_wo_date}
                                          onChange={(e) => handleSalesInputChange(e, index, lineindex, "po_wo_date")}
                                          className="invoice_narrow_input_quantity"
                                          style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                        />
                                      </td>
                                      {/* SALES REMARKS */}
                                      <td>
                                        <input
                                          type="text"
                                          value={row.salesRemarks}
                                          onChange={(e) =>
                                            handleSalesInputChange(e, index, lineindex, "salesRemarks")}
                                          className="invoice_narrow_input_remarks"
                                          style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                        />
                                      </td>
                                      {/* SALES CONTRACT VALUE */}
                                      {/* <td>
                              <input
                                type="number"
                                value={row.salesContractValue}
                                disabled
                                onChange={(e) => {
                                  handleInputChange(e, index, lineindex, "salesContractValue");
                                }}
                                className="invoice_small_input"
                                style={{ fontFamily: 'Work Sans' }}
                              />
                            </td> */}
                                      {/* SALES QUANTITY */}
                                      <td>
                                        <input
                                          type="number"
                                          value={row.SalesunitQuantity}
                                          onChange={(e) => {
                                            handleSalesInputChange(e, index, lineindex, "SalesunitQuantity");
                                          }}
                                          className="invoice_narrow_input_quantity"
                                          style={{ fontFamily: 'Work Sans' }}
                                        />
                                      </td>
                                      {/* SALES RATE */}
                                      <td>
                                        <input
                                          type="number"
                                          value={row.salesRate}
                                          onChange={(e) => handleSalesInputChange(e, index, lineindex, "salesRate")}
                                          className="invoice_narrow_input"
                                          style={{ fontFamily: 'Work Sans' }}
                                        />
                                      </td>
                                      {/* SALES NET TOTAL */}
                                      <td>
                                        <input
                                          type="number"
                                          value={row.salesNetTotal}
                                          readOnly
                                          className="invoice_narrow_input"
                                          style={{ fontFamily: 'Work Sans' }}
                                        />
                                      </td>
                                      {/* SALES ATTACHMENT */}
                                      <td>
                                        <div className="file_upload_wrapper">
                                          {!row.salesUploadedFiles || row.salesUploadedFiles.length === 0 ? (
                                            row.salesAttachment ? (
                                              <div className="download_attachment_section" style={{ display: 'flex', justifyContent: 'center' }}>
                                                <button
                                                  className="download_btn"
                                                  onClick={() => window.open(row.salesAttachment, '_blank')}
                                                  style={{ height: 'auto', width: 'auto', padding: '12px' }}
                                                >
                                                  <img src={download_arrow} alt="Download" className="download_icon" />
                                                  <span className="download_text">Download</span>
                                                </button>
                                                <button
                                                  className="remove_file_btn"
                                                  onClick={() => handleRemoveSalesAttachment(category.id, index, lineindex)}
                                                >
                                                  ⨉
                                                </button>
                                              </div>
                                            ) : (
                                              <label className="file_upload" style={{ padding: '0px' }}>
                                                <input
                                                  type="file"
                                                  multiple
                                                  onChange={(e) => handleSalesFileUpload(e, category.id, index, lineindex)}
                                                  style={{ display: "none" }}
                                                />
                                                <img src={upload_icon} alt="Upload" className="upload_icon" />
                                                <span className="upload_text">Upload</span>
                                              </label>
                                            )
                                          ) : null}

                                          {row.salesUploadedFiles && row.salesUploadedFiles.length > 0 && (
                                            <div className="uploaded_files_list">
                                              {row.salesUploadedFiles.map((file, fileIndex) => (
                                                <div key={fileIndex} className="uploaded_file_item">
                                                  <div className="file_info">
                                                    <img
                                                      src={
                                                        file.name.match(/\.(xls|xlsx)$/i)
                                                          ? excel_icon
                                                          : upload_icon
                                                      }
                                                      alt="File type"
                                                      className="file_type_icon"
                                                    />
                                                    <span className="file_name">{file.name}</span>
                                                  </div>
                                                  <button
                                                    className="remove_file_btn"
                                                    onClick={() => handleRemoveSalesFile(category.id, index, lineindex, fileIndex)}
                                                  >
                                                    ⨉
                                                  </button>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      </td>

                                      <td
                                        style={{
                                          position: 'sticky',
                                          right: 0,
                                          background: 'white',
                                          zIndex: 1,
                                          textAlign: 'center',
                                          padding: 0,
                                          boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                        }}
                                      >
                                        <button onClick={() => deleteRow(category.id, lineindex, 'sales')} className="delete-btn">
                                          <img src={delete_icon} alt="Delete" />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div
                                className="add_new_row"
                                onClick={() => addSalesRow(index)}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="add_new_row_popup">
                                  <img src={plus_icon} alt="" />
                                  Add Sales Row
                                </span>
                              </div>
                            </div>
                          )}

                          {(getViewModeForCategory(category.id) === "split") && <DraggableDivider leftRef={salesRef} rightRef={costRef} />}

                            {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "cost") && (
                              <div className="table-container cost-table" ref={costRef} style={{
                                position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "1 1 0px" : "1 1 100%",
                                width: getViewModeForCategory(category.id) === "split" ? "auto" : "100%", transition: 'flex 0.2s ease',
                                display: getViewModeForCategory(category.id) === "split" ? "block" :
                                  (getViewModeForCategory(category.id) === "cost" ? "block" : "none")
                              }}>
                                <table className="invoice_table">
                                  <thead>
                                    <tr>
                                      <th colSpan="12" style={{ backgroundColor: '#E0EFFF', color: '#097BED', padding: '10px' }}>COST</th>
                                    </tr>
                                    <tr>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>CHARGE CODE</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>DESCRIPTION</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV NUMBER</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV DATE</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO DATE</th>
                                      <th style={{ backgroundColor: '#E0EFFF', padding: '10px' }}>REMARKS</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>QUANTITY</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>RATE</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>NET TOTAL</th>
                                      <th style={{ backgroundColor: '#E0EFFF' }}>ATTACHMENT</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {category.costRows.map((row, lineindex) => (
                                      <tr key={lineindex}>
                                        <td style={{ position: "relative" }}>
                                          <input
                                            type="text"
                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                            value={costInputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              handleCostInputChange(e, index, lineindex, "chargecode");
                                              setCostInputValues((prev) => ({
                                                ...prev,
                                                [index]: {
                                                  ...prev[index],
                                                  [lineindex]: val,
                                                },
                                              }));
                                              fetchCostSuggestions(val, lineindex, index);
                                            }}
                                            onFocus={() => {
                                              const list = costSuggestionsMap[index]?.[lineindex] || [];
                                              if (list.length > 0) {
                                                setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                              }
                                            }}
                                            onBlur={() => {
                                              setTimeout(() => {
                                                setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                              }, 200);
                                            }}
                                            className="invoice_narrow_input_chargecode"
                                            placeholder="Search"
                                          />
                                          {showCostSuggestionsMap[`${index}_${lineindex}`] && costSuggestionsMap[index]?.[lineindex]?.length > 0 && (
                                            <ul
                                              style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                right: 0,
                                                backgroundColor: "white",
                                                border: "1px solid #ccc",
                                                zIndex: 999,
                                                maxHeight: "150px",
                                                overflowY: "auto",
                                                margin: 0,
                                                padding: 0,
                                                listStyle: "none",
                                                fontFamily: 'Work Sans'
                                              }}
                                            >
                                              {costSuggestionsMap[index]?.[lineindex].map((item) => (
                                                <li
                                                  key={item.value}
                                                  onMouseDown={() => {
                                                    const selected = item.label;
                                                    const chargeId = item.value;

                                                  setCostInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: selected,
                                                    },
                                                  }));

                                                  setSelectedCostChargeIds((prev) => ({
                                                    ...prev,
                                                    [`${index}_${lineindex}`]: chargeId
                                                  }));

                                                  handleCostInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                  setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));

                                                  const splitParts = selected.split("-");
                                                  const chargeCodeOnly = splitParts[0] || "";
                                                  const descriptionOnly = splitParts.slice(1).join("-") || "";

                                                  setCostInputValues((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [lineindex]: chargeCodeOnly,
                                                    },
                                                  }));

                                                    handleCostInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");
                                                    handleCostInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                                  }}
                                                  style={{
                                                    padding: "8px",
                                                    cursor: "pointer",
                                                    borderBottom: "1px solid #eee",
                                                  }}
                                                >
                                                  {item.label}
                                                </li>
                                              ))}
                                            </ul>
                                          )}
                                        </td>
                                        <td>
                                          <input
                                            type="text"
                                            value={row.description}
                                            onChange={(e) => {
                                              handleCostInputChange(e, index, lineindex, "description");
                                            }}
                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                            className="invoice_narrow_input_description"
                                          />
                                        </td>

                                      {/* COST VENDOR */}
                                      <td style={{ position: 'relative' }}>
                                        <input
                                          type="text"
                                          className="contracts_small_input"
                                          style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                          value={vendorInputValues[`${index}_${lineindex}`] || ""}
                                          onChange={async (e) => {
                                            const val = e.target.value;
                                            setVendorInputValues(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: val,
                                            }));

                                            if (val.length >= 1) {
                                              const suggestions = await fetchVendorSuggestions(val);
                                              setVendorSuggestions(suggestions);
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: true,
                                              }));
                                            } else {
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: false,
                                              }));
                                            }
                                          }}
                                          onFocus={async () => {
                                            const val = vendorInputValues[`${index}_${lineindex}`] || "";
                                            if (val.length >= 1) {
                                              const suggestions = await fetchVendorSuggestions(val);
                                              setVendorSuggestions(suggestions);
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: true,
                                              }));
                                            }
                                          }}
                                          onBlur={() => {
                                            setTimeout(() => {
                                              setShowVendorSuggestions(prev => ({
                                                ...prev,
                                                [`${index}_${lineindex}`]: false,
                                              }));
                                            }, 200);
                                          }}
                                          placeholder="Search vendor"
                                        />

                                          {showVendorSuggestions[`${index}_${lineindex}`] && vendorSuggestions.length > 0 && (
                                            <ul
                                              style={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                right: 0,
                                                backgroundColor: "white",
                                                border: "1px solid #ccc",
                                                zIndex: 999,
                                                maxHeight: "150px",
                                                overflowY: "auto",
                                                margin: 0,
                                                padding: 0,
                                                listStyle: "none",
                                              }}
                                            >
                                              {vendorSuggestions.map((vendor) => (
                                                <li
                                                  key={vendor.value}
                                                  onMouseDown={() => {
                                                    setVendorInputValues(prev => ({
                                                      ...prev,
                                                      [`${index}_${lineindex}`]: vendor.label,
                                                    }));
                                                    setSelectedVendorIds(prev => ({
                                                      ...prev,
                                                      [`${index}_${lineindex}`]: vendor.value,
                                                    }));
                                                    setShowVendorSuggestions(prev => ({
                                                      ...prev,
                                                      [`${index}_${lineindex}`]: false,
                                                    }));
                                                  }}
                                                  style={{
                                                    padding: "8px",
                                                    cursor: "pointer",
                                                    borderBottom: "1px solid #eee",
                                                  }}
                                                >
                                                  {vendor.label}
                                                </li>
                                              ))}
                                            </ul>
                                          )}
                                        </td>

                                        <td>
                                          <input
                                            type="text"
                                            value={row.vendor_invoice_number || ""}
                                            onChange={(e) =>
                                              handleCostInputChange(e, index, lineindex, "vendor_invoice_number")
                                            }
                                            className="invoice_narrow_input_quantity"
                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                            placeholder="Enter Invoice No"
                                          />
                                        </td>

                                        <td>
                                          <input
                                            type="date"
                                            value={row.vendor_invoice_date || ""}
                                            onChange={(e) =>
                                              handleCostInputChange(e, index, lineindex, "vendor_invoice_date")
                                            }
                                            className="invoice_narrow_input_quantity"
                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                          />
                                        </td>

                                        <td>
                                          <input
                                            type="text"
                                            value={row.po_wo_number}
                                            onChange={(e) => {
                                              if (e.target.value.length <= 10) {
                                                handleCostInputChange(e, index, lineindex, "po_wo_number");
                                              }
                                            }}
                                            className="invoice_narrow_input_quantity"
                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                          />
                                        </td>
                                        <td>
                                          <input
                                            type="date"
                                            value={row.po_wo_date}
                                            onChange={(e) => handleCostInputChange(e, index, lineindex, "po_wo_date")}
                                            className="invoice_narrow_input_quantity"
                                            style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                          />
                                        </td>




                                        {/* COST REMARKS */}
                                        <td>
                                          <input
                                            type="text"
                                            value={row.costRemarks}
                                            onChange={(e) =>
                                              handleCostInputChange(e, index, lineindex, "costRemarks")}
                                            className="invoice_narrow_input_remarks"
                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                          />
                                        </td>

                                        {/* COST QUANTITY */}
                                        <td>
                                          <input
                                            type="number"
                                            value={row.CostunitQuantity}
                                            onChange={(e) => {
                                              handleCostInputChange(e, index, lineindex, "CostunitQuantity");
                                            }}
                                            className="invoice_narrow_input_quantity"
                                            style={{ fontFamily: 'Work Sans' }}
                                          />
                                        </td>
                                        {/* COST RATE */}
                                        <td>
                                          <input
                                            type="number"
                                            value={row.costRate}
                                            onChange={(e) => handleCostInputChange(e, index, lineindex, "costRate")}
                                            className="invoice_narrow_input"
                                            style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                          />
                                        </td>
                                        {/* COST NET TOTAL */}
                                        <td>
                                          <input
                                            type="number"
                                            value={row.costNetTotal}
                                            readOnly
                                            className="invoice_narrow_input"
                                            style={{ fontFamily: 'Work Sans' }}
                                          />
                                        </td>

                                      {/* COST ATTACHMENT */}
                                      <td>
                                        <div className="file_upload_wrapper">
                                          {!row.costUploadedFiles || row.costUploadedFiles.length === 0 ? (
                                            row.costAttachment ? (
                                              <div className="download_attachment_section" style={{ display: 'flex', justifyContent: 'center' }}>
                                                <button
                                                  className="download_btn"
                                                  onClick={() => window.open(row.costAttachment, '_blank')}
                                                  style={{ height: 'auto', width: 'auto', padding: '12px' }}
                                                >
                                                  <img src={download_arrow} alt="Download" className="download_icon" />
                                                  <span className="download_text">Download</span>
                                                </button>
                                                <button
                                                  className="remove_file_btn"
                                                  onClick={() => handleRemoveCostAttachment(category.id, index, lineindex)}
                                                >
                                                  ⨉
                                                </button>
                                              </div>
                                            ) : (
                                              <label className="file_upload">
                                                <input
                                                  type="file"
                                                  multiple
                                                  onChange={(e) => handleCostFileUpload(e, category.id, index, lineindex)}
                                                  style={{ display: "none" }}
                                                />
                                                <img src={upload_icon} alt="Upload" className="upload_icon" />
                                                <span className="upload_text">Upload</span>
                                              </label>
                                            )
                                          ) : null}

                                          {row.costUploadedFiles && row.costUploadedFiles.length > 0 && (
                                            <div className="uploaded_files_list">
                                              {row.costUploadedFiles.map((file, fileIndex) => (
                                                <div key={fileIndex} className="uploaded_file_item">
                                                  <div className="file_info">
                                                    <img
                                                      src={
                                                        file.name.match(/\.(xls|xlsx)$/i)
                                                          ? excel_icon
                                                          : upload_icon
                                                      }
                                                      alt="File type"
                                                      className="file_type_icon"
                                                    />
                                                    <span className="file_name">{file.name}</span>
                                                  </div>
                                                  <button
                                                    className="remove_file_btn"
                                                    onClick={() => handleRemoveCostFile(category.id, index, lineindex, fileIndex)}
                                                  >
                                                    ⨉
                                                  </button>
                                                </div>
                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                      <td
                                        style={{
                                          position: 'sticky',
                                          right: 0,
                                          background: 'white',
                                          zIndex: 1,
                                          textAlign: 'center',
                                          padding: 0,
                                          boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                        }}
                                      >
                                        <button onClick={() => deleteRow(category.id, lineindex, 'cost')} className="delete-btn">
                                          <img src={delete_icon} alt="Delete" />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                              <div
                                className="add_new_row"
                                onClick={() => addCostRow(index)}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="add_new_row_popup">
                                  <img src={plus_icon} alt="" />
                                  Add Cost Row
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>

          <div className="existing-job-popup-actions">
            <button
              className="existing-job-cancel-btn"
              onClick={() => handleGenerateInvoice('sales')}
              disabled={!existingJobSelected}>Generate Sales Invoice</button>
            <button
              className="existing-job-add-btn"
              onClick={handleCostInvoiceClick}
              disabled={!existingJobSelected}
            >
              Generate Cost Invoice
            </button>
          </div>
        </div>

      </div>
      <AddExistingNonPoJobModal
        isOpen={showPoPopup}
        onClose={() => setShowPoPopup(false)}
        invoiceMode={invoiceMode}
        setInvoiceMode={setInvoiceMode}
        onSubmit={() => {

          if (!invoiceMode) {
            toast.error("Please select PO or Non-PO to generate the Cost invoice.");
            return;
          }

          setShowPoPopup(false);
          handleGenerateInvoice("cost");
        }}
        title="Generate Cost Invoice"
      />
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
    </>
  );
};

export default AddExistingJob;